<template>
  <div class="home">
    <el-carousel :height="bannerHeight + 'px'">
      <el-carousel-item v-for="item in Carousellist">
        <img :src="item.ImgUrl" />
      </el-carousel-item>
    </el-carousel>
    <article class="newhome" v-cloak>
      <!--公告-->
      <div style="display: flex; justify-content: space-between">
        <div>
          <div class="notice-border">
            <p class="bgC52D23"></p>
            <p class="bgC52D23 bgC52D23_2"></p>
            <p class="notice-border-text">招标公告</p>
            <router-link :to="'/purchasenotice'" class="notice-border-more" target="_blank">更多>></router-link>
          </div>
          <div class="notice-content">
            <li v-for="item in tenderslist" class="notice-text">
              <div class="circle-with-text">
                <span class="circle"></span>
                <router-link :to="'/purchasedetail?type=' + item.Type + '&id=' + item.Id" :title="item.Title"
                  class="title-one" target="_blank">{{ item.Title }}</router-link>
              </div>
              <p>{{ item.PublishTime | truncate }}</p>
            </li>
          </div>
        </div>
        <div>
          <div class="notice-border">
            <p class="bgC52D23"></p>
            <p class="bgC52D23 bgC52D23_2"></p>
            <p class="notice-border-text">中标公告</p>
            <router-link :to="'/purchasenotice'" class="notice-border-more" target="_blank">更多>></router-link>
          </div>
          <div class="notice-content">
            <li v-for="item in zbgglist" class="notice-text">
              <div class="circle-with-text">
                <span class="circle"></span>
                <router-link :to="'/purchasedetail?type=' + item.Type + '&Category=5&id=' + item.ProjectId"
                  :title="item.Title" class="title-one" target="_blank">{{ item.Title }}</router-link>
              </div>
              <p>{{ item.PublishTime | truncate }}</p>
            </li>
          </div>
        </div>
      </div>
      <!--公告，法规-->
      <div style="display: flex; justify-content: space-between">
        <div>
          <div class="notice-border">
            <p class="bgC52D23"></p>
            <p class="bgC52D23 bgC52D23_2"></p>
            <p class="notice-border-text">补充公告</p>
            <router-link :to="'/purchasenotice'" class="notice-border-more" target="_blank">更多>></router-link>
          </div>
          <div class="notice-content">
            <li v-for="item in bcgglist" class="notice-text">
              <div class="circle-with-text">
                <span class="circle"></span>
                <router-link :to="'/purchasedetail?type=' + item.Type + '&Category=3&id=' + item.ProjectId"
                  :title="item.Title" class="title-one" target="_blank">{{ item.Title }}</router-link>
              </div>
              <p>{{ item.PublishTime | truncate }}</p>
            </li>
          </div>
        </div>
        <div>
          <div class="notice-border">
            <p class="bgC52D23"></p>
            <p class="bgC52D23 bgC52D23_2"></p>
            <p class="notice-border-text">政策法规</p>
            <router-link :to="'/Policy'" class="notice-border-more" target="_blank">更多>></router-link>
          </div>
          <div class="notice-content">
            <li v-for="item in Policylist" class="notice-text">
              <div class="circle-with-text">
                <span class="circle"></span>
                <router-link :to="'/Policydetail?id=' + item.Id" :title="item.Title" class="title-one"
                  target="_blank">{{
      item.Title
    }}</router-link>
              </div>
              <p>{{ item.CreateTime | truncate }}</p>
            </li>
          </div>
        </div>
      </div>
      <!--图片-->
      <img style="padding: 40px 0px" src="../assets/banner_home.png" />
      <!--网上竞价-->
      <div style="display: flex; margin: 30px 0px">
        <div style="font-size: 20px; width: 160px">
          <li v-for="(item, index) in Biddingtype" class="br-red" @click="doActive2(index)"
            :class="{ active: index == jjcurrent }">
            {{ item.WordText }}
            <span style="
                border-right: 10px solid #ffffff;
                border-top: 10px solid transparent;
                border-bottom: 10px solid transparent;
                float: right;
                margin-top: 5px;
              ">
            </span>
          </li>
        </div>
        <div style="
            flex: 1;
            border: 1px solid #df3e3e;
            border-left: 0;
            align-items: center;
            padding: 20px 20px 0px 20px;
            width: 800px;
            margin-right: 20px;
          ">
          <div style="width: 100%; height: 42px; justify-content: center; display: flex" v-if="jjcurrent != 1">
            <input id="jb_title" type="text" placeholder="请输入关键词（招标编号或项目名称）"
              style="text-indent: 10px; width: 400px; height: 42px; border-radius: 5px 0px 0px 5px; border: 1px solid #df3e3e" />
            <a @click="searchjb_title(jjcurrent)" style="
                background-color: #df3e3e;
                color: #ffffff;
                width: 100px;
                height: 42px;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                padding-top: 10px;
              ">搜索</a>
          </div>
          <div style="width: 100%; height: 42px; justify-content: center; display: flex" v-else>
            <input id="jb_title" type="text" placeholder="请输入关键词（标题）"
              style="text-indent: 10px; width: 400px; height: 42px; border-radius: 5px 0px 0px 5px; border: 1px solid #df3e3e" />
            <a @click="searchjb_title(jjcurrent)" style="
                background-color: #df3e3e;
                color: #ffffff;
                width: 100px;
                height: 42px;
                border-radius: 0px 5px 5px 0px;
                text-align: center;
                padding-top: 10px;
              ">搜索</a>
          </div>
          <el-table :data="this.Biddinglist" style="width: 100%; font-size: 18px"
            :row-style="{ height: '52px', 'font-size': '16px' }" :cell-style="{ padding: '0px' }"
            :header-row-style="{ height: '20px' }" :fit="true">
            <el-table-column v-if="jjcurrent == 1" prop="Title" label="标题"> 
              <template slot-scope="scope">
                <router-link v-if="jjcurrent == 1" :to="'/ResultbcNotice?id=' + scope.row.Id" target="_blank">{{scope.row.Title }}</router-link>
              </template>
            </el-table-column>
            <el-table-column v-if="jjcurrent != 1" :prop="jjcurrent == 2 ? 'Subtitle' : 'Title'" label="招标编号" width="200"> </el-table-column>
            <el-table-column v-if="jjcurrent != 1" label="招标项目">
              <template slot-scope="scope">
                <router-link v-if="jjcurrent == 2" :to="'/ResultNotice?id=' + scope.row.Id" target="_blank">{{
      jjcurrent == 2 ? scope.row.Title : scope.row.Name
    }}</router-link>
                <router-link v-else :to="'/Tenderdetail?id=' + scope.row.Id" target="_blank">{{
      jjcurrent == 2 ? scope.row.Title : scope.row.Name
    }}</router-link>
              </template>
            </el-table-column>
            <el-table-column :prop="jjcurrent == 2 || jjcurrent == 1 ? 'PublishTime' : 'JEndTime'"
              :label="jjcurrent == 2 || jjcurrent == 1 ? '发布时间' : '竞价截止时间'" width="200">
            </el-table-column>
          </el-table>
        </div>
        <!--登录-->
        <leftlogin :formData.sync="form"></leftlogin>
      </div>
      <!--关于我们 -->
    </article>
    <img style="opacity: 1; margin-top: 10px; height: 400px; position: absolute; overflow: hidden"
      src="../assets/gybg.png" />
    <div style="
        z-index: 1;
        position: absolute;
        display: flex;
        left: 0px;
        right: 0px;
        text-align: center;
        height: 400px;
        justify-content: center;
        align-items: center;
        text-align: center;
      ">
      <div style="width: 1000px">
        <p style="padding-top: 10px; font-size: 40px; color: #ffffff">关于盛鑫</p>
        <p style="padding-top: 30px; color: #ffffff; font-size: 20px">
          福建盛鑫招标代理有限公司成立于2007年8月，是经福州市鼓楼区市场监督管理局登记注册，专业从事工程招标代理、政府采购法规定的货物、工程和服务的采购代理业务和政府采购咨询服务、工程造价咨询、工程咨询服务的
          招标代理机构。
        </p>
        <p style="padding-top: 14px; color: #ffffff; font-size: 20px">
          2009年取得财政部颁发的政府采购代理甲级资格，2015年已按财政部的要求完成了首次网上登记等相关工作、
          2016年完成机电产品国际招标代理登记备案，具备从事机电产品国际招标采购资格。
        </p>
        <p style="padding-top: 14px; color: #ffffff; font-size: 20px">福建省政府采购综合评价中诚信等级为A+级。</p>
      </div>
    </div>
    <div style="padding-top: 500px; text-align: center">
      <div style="padding-bottom: 30px">
        <p style="font-size: 40px; color: #222222">荣誉资质</p>
        <p style="padding-top: 14px; color: #999999; font-size: 18px">HONORCENTER</p>
      </div>
      <div style="width: 1400px; text-align: center; margin: auto">
        <!-- <el-row type="flex" justify="center">             -->
        <div id="father" class="grid-content bg-pink">
          <div id="swiper-box" class="swiper-box" :style="{ transform: 'translateX(' + currentOffset + 'px)' }">
            <div v-for="i in Honorllist" class="card-item" :style="{ minWidth: width }">
              <el-card :body-style="{ padding: '0px' }">
                <img :src="i.ImgUrl" class="image" />
              </el-card>
            </div>
          </div>
          <i class="el-icon-arrow-left" @click="left"></i>
          <i class="el-icon-arrow-right" @click="right"></i>
        </div>
        <!-- </el-row> -->
      </div>
    </div>
    <!--新闻中心 -->
    <article class="newhome" v-cloak>
      <div class="news">
        <div style="display: flex; width: 630px">
          <p style="font-size: 40px; color: red">新闻中心</p>
          <p style="font-size: 30px; padding: 10px 0px 4px 20px">NEWSCENTER</p>
        </div>
        <div style="display: flex; flex: 1; padding-left: 40px">
          <a class="fc-999" @click="Impart(1)" v-on:click="newscli = 1"
            :style="newscli == 1 ? 'color: #DF3E3E;' : ''">企业动态</a>
          <div class="newsclick" :style="newscli == 1 ? 'display:block' : ''"></div>
          <a class="fc-999" @click="Impart(2)" v-on:click="newscli = 2"
            :style="newscli == 2 ? 'color: #DF3E3E;' : ''">办事指南</a>
          <div class="newsclick" :style="newscli == 2 ? 'display:block;margin-left:155px' : ''"></div>
        </div>
        <router-link v-show="newscli == 1" style="font-size: 24px; color: #cccccc; float: right"
          :to="'/News?type=1'">MORE+</router-link>
        <router-link v-show="newscli == 2" style="font-size: 24px; color: #cccccc; float: right"
          :to="'/Guide'">MORE+</router-link>
      </div>
      <div style="display: flex">
        <el-carousel style="width: 630px; height: 390px">
          <el-carousel-item v-for="item in adlist" style="width: 630px; height: 390px">
            <img :src="item.ImgUrl" />
          </el-carousel-item>
        </el-carousel>
        <div style="font-size: 18px; flex: 1; padding-left: 40px">
          <li v-for="item in newslist" style="margin-bottom: 35px; list-style-type: square; color: #666666"
            v-if="newscli == 1">
            <router-link v-show="newscli == 1" :title="item.Title"
              style="width: 450px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; line-height: 18px"
              :to="'/Newsdetail?id=' + item.Id + '&type=1'">{{ item.Title }}</router-link>
            <span style="float: right; color: #cccccc"> {{ item.CreateTime.slice(0, 10) }} </span>
          </li>
          <li v-for="item in guidelist" style="margin-bottom: 35px; list-style-type: square; color: #666666"
            v-if="newscli == 2">
            <router-link :title="item.Title"
              style="width: 450px; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; line-height: 18px"
              :to="'/Guidedetail?id=' + item.Id + '&type=' + item.Category">{{ item.Title }}</router-link>
            <span style="float: right; color: #cccccc"> {{ item.CreateTime.slice(0, 10) }} </span>
          </li>
        </div>
      </div>
      <!--友情链接-->
      <div class="link">
        <span style="white-space: nowrap; margin-right: 20px">友情链接：</span>
        <li v-for="item in linkslist" style="margin-right: 50px">
          <a :href="item.Word_Value" target="_blank" :title="item.Word_Text"
            style="font-size: 18px; white-space: nowrap">{{
            item.Word_Text
            }}</a>
        </li>
      </div>
    </article>
  </div>
</template>

<script>
// @ is an alias to /src
import util from "../../util/date";
import leftlogin from "../components/leftlogin.vue";
export default {
  name: "home",
  components: { leftlogin },
  data() {
    return {
      // 图片父容器高度
      bannerHeight: 1000,
      // 浏览器宽度
      screenWidth: 0,
      page: 1,
      TotalCount: 1,
      pictLoading: true,
      isShow: true,
      Carousellist: [],
      Honorllist: [],
      adlist: [],
      newslist: [],
      tenderstype: [], //招标类型
      tenderslist: [], //招标列表
      zbgglist: [],
      bcgglist: [],
      Biddingtype: [
        {
          WordText: "网上竞价",
        },
        {
          WordText: "补充公告",
        },
        {
          WordText: "结果公告",
        },
      ], //投标类型
      Biddinglist: [], //投标列表
      expDate: "",
      newscli: 1,
      zbcurrent: 0,
      jjcurrent: 0,
      Policylist: [],
      Performancelist: [],
      guidelist: [],
      linkslist: [],
      form: {
        name: "",
        pass: "",
        type: "",
      },
      zb_title: "",
      //轮播图的
      currentOffset: 0,
      width: {},
      fatherWith: 0,
      box: "", // dom
    };
  },

  created() {
    var that = this;
    that.expDate = window.localStorage.getItem("USER_EXP") || "";
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];
    that.tenderstype = menulist.filter(function (item) {
      return item.Word_Group_Key == "IndustryType";
    });
    if (menulist.length > 0) {
      that.tenderstype.unshift({ Id: 0, Word_Group_Key: "IndustryType", Word_Text: "招标公告", Word_Value: "0" });
      that.zbcurrent = that.tenderstype[0].Id;
      that.zbCategory = that.tenderstype[0].Word_Value;
      that.getzbNotice();
    }
  },
  mounted() {
    this.getAdData();
    this.getData();
    this.getTender();
    this.getPolicy();
    this.getPerformance();
    this.getGuide();
    this.getlinksdata();
    this.getzbggNotice();
    this.getbcggNotice();
    this.expDate = window.localStorage.getItem("USER_EXP") || "";
    // 首次加载时,需要调用一次
    this.screenWidth = window.innerWidth;
    this.setSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setSize();
    };

    //轮播图的
    this.setCardWidth();
    this.box = document.querySelector("#swiper-box");
    window.addEventListener("resize", () => {
      this.currentOffset = 0;
      this.setCardWidth();
    });
  },
  filters: {
    truncate(value) {
      return value.substring(0, 10);
    },
  },
  methods: {
    setCardWidth() {
      const father = document.querySelector("#father");
      this.fatherWith = father.clientWidth;
      console.log("fatherWidth", this.fatherWith);
      this.width = (this.fatherWith - 20) / 4 + "px";
      console.log("fatherWidth", this.width);
    },

    right() {
      console.log(this.currentOffset);
      if (this.currentOffset <= (-(this.fatherWith - 50) / 5) * (10 - 5)) return;
      this.currentOffset -= (this.fatherWith - 50) / 5;
    },
    left() {
      console.log(this.currentOffset);
      if (this.currentOffset >= -2) return;
      this.currentOffset += (this.fatherWith - 50) / 5;
    },
    //上面都是轮播图的
    formatCreateTime: function (row) {
      return !row.bCreateTime || row.bCreateTime == "" ? "" : util.formatDate.format(new Date(row.bCreateTime), "yyyy-MM-dd");
    },
    getAdData() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 99,
        OrderByFileds: "Id",
      };
      that.$api.get("Ad/Get", params, (r) => {
        that.Carousellist = r.response.data.filter(function (item) {
          return item.Type == 1;
        });
        that.adlist = r.response.data.filter(function (item) {
          return item.Type == 2;
        });
        that.Honorllist = r.response.data.filter(function (item) {
          return item.Type == 3;
        });
      });
    },
    getData() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "CreateTime desc",
        Status: 1,
      };
      that.$api.get("News/Get", params, (r) => {
        that.newslist = r.response.data;
      });
    },
    getImpartData() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "CreateTime desc",
      };
      that.$api.get("Impart/Get", params, (r) => {
        that.newslist = r.response.data;
      });
    },
    getzbNotice() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "PublishTime desc",
        Type: that.zbCategory,
      };
      this.$api.get("/Notice/Get", params, (r) => {
        that.tenderslist = r.response.data;
      });
    },
    getzbggNotice() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "p.PublishTime desc",
        Type: that.zbCategory,
        Category: 5,
      };
      this.$api.get("/Notice/GetCategory", params, (r) => {
        that.zbgglist = r.response.data;
      });
    },
    getbcggNotice() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "p.PublishTime desc",
        Type: that.zbCategory,
        Category: 3,
      };
      this.$api.get("/Notice/GetCategory", params, (r) => {
        that.bcgglist = r.response.data;
      });
    },
    searchzb_title() {
      var title = document.getElementById("zb_title").value;
      this.$router.replace("/purchasenotice?search=" + title);
    },
    searchjb_title(index) {
      console.log(index);
      var title = document.getElementById("jb_title").value;
      if (index == 2) this.$router.replace("/Tender?id=2&search=" + title);
      if (index == 1) this.$router.replace("/Tender?id=3&search=" + title);
      else this.$router.replace("/Tender?search=" + title);
    },
    getTender() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 5,
        OrderByFileds: "Id desc",
      };
      that.$api.get("/Tender/Get", params, (r) => {
        that.Biddinglist = r.response.data;
        // if (that.jjcurrent == 1) {
        //   that.Biddinglist = that.Biddinglist.filter(function (item) {
        //     return that.convertDateFromString(item.JEndTime) > new Date();
        //   });
        // }
      });
    },
    getTenderbcNotice(){
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 5,
        OrderByFileds: "Id desc",
      };
      that.$api.get("/supplyNotice/Get", params, (r) => {
        that.Biddinglist = r.response.data;
        // if (that.jjcurrent == 1) {
        //   that.Biddinglist = that.Biddinglist.filter(function (item) {
        //     return that.convertDateFromString(item.JEndTime) > new Date();
        //   });
        // }
      });
    },
    getResultNotice() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 5,
        OrderByFileds: "p.Id desc",
      };
      that.$api.get("/ResultNotice/GetList", params, (r) => {
        that.Biddinglist = r.response.data;
      });
    },
    getPolicy() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 7,
        OrderByFileds: "p.CreateTime desc",
      };
      this.$api.get("/Policy/Get", params, (r) => {
        that.Policylist = r.response.data;
        that.total = r.response.dataCount;
        that.isShow = false;
      });
    },
    getPerformance() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 8,
        OrderByFileds: "p.CreateTime desc",
      };
      that.$api.get("/Performance/Get", params, (r) => {
        that.Performancelist = r.response.data;
      });
    },
    getGuide() {
      var that = this;
      var params = {
        PageIndex: 1,
        PageSize: 8,
        OrderByFileds: "p.CreateTime desc",
      };
      that.$api.get("/Guide/Get", params, (r) => {
        that.guidelist = r.response.data;
      });
    },
    getlinksdata() {
      var that = this;
      that.$api.get("Config/GetGroupList?groupkey=Links", null, (r) => {
        that.linkslist = r.response;
      });
    },
    setSize: function () {
      // 通过浏览器宽度(图片宽度)计算高度
      this.bannerHeight = (420 / 1920) * this.screenWidth;
    },
    zbdoActive: function (item) {
      var that = this;
      that.zbcurrent = item.Id;
      that.zbCategory = item.Word_Value;
      that.getzbNotice();
    },
    doActive2: function (index) {
      console.log(index);
      this.jjcurrent = index;
      if (index == 2) this.getResultNotice();
      else if(index == 1) this.getTenderbcNotice();
      else this.getTender();
    },
    convertDateFromString(dateString) {
      if (dateString) {
        var date = new Date(dateString.replace(/-/g, "/"));
        return date;
      }
    },
    Impart(item) {
      if (item == 2) this.getGuide();
      else this.getData();
    },
  },
  computed: {},
  watch: {
    $route(to) {
      this.list = [];
      this.isShow = true;
      this.page = to.query.page;
      this.getData();
    },
  },
};
</script>

<style>
.home {
  background-color: #fff;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.viewmore-row {
  float: right;
  background: #12b7de;
  color: #fff;
  border-radius: 3px;
  padding: 0px 10px;
  height: 30px;
}

.bg-purple {
  background: #eaeaea;
  -webkit-animation: loading 1s ease-in-out infinite;
  animation: loading 1s ease-in-out infinite;
}

@keyframes loading {
  0% {
    width: 90%;
  }

  50% {
    width: 100%;
  }

  to {
    width: 90%;
  }
}

[v-cloak] {
  display: none !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

img {
  /*设置图片宽度和浏览器宽度一致*/
  width: 100%;
  height: inherit;
}

.textone {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 25px;
  max-height: 25px;
  width: 480px;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.news-border {
  margin-right: 30px;
  width: 414px;
  height: 429px;
  background: #ffffff;
  box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.16);
  border: 1px solid #cccccc;
  opacity: 1;
}

.news-text {
  justify-content: flex-end;
  list-style-type: square;
  font-size: 16px;
  padding: 20px 20px 0px 20px;
}

.link {
  flex-wrap: wrap;
  border: 1px solid #cccccc;
  height: 110px;
  display: flex;
  align-items: center;
  margin: 60px 0px;
  padding-left: 30px;
  font-size: 18px;
}

.news {
  display: flex;
  padding: 40px 0px 20px 0px;
  color: #999999;
  align-items: center;
}

.newsclick {
  width: 116px;
  height: 25px;
  background: #f5c4c4;
  border-radius: 2px 2px 2px 2px;
  opacity: 0.3;
  margin-top: 15px;
  position: absolute;
  display: none;
}

input::-webkit-input-placeholder {
  color: #e98989;
  padding: 10px 0px 16px 10px;
}

.fc-999 {
  font-size: 24px;
  color: #999999;
  margin-right: 60px;
}

.br-red {
  border: 1px solid #ccc;
  padding: 45px 0px 25px 30px;
  text-align: left;
  border-right-color: red;
  height: 125px;
  color: #666666;
  font-size: 22px;
}

.active {
  color: #ffffff;
  background: #df3e3e;
}

.title-one {
  width: 470px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  line-height: 16px;
}

.bgDF3E3E {
  width: 132px;
  margin-left: 123px;
  height: 41px;
  background: #df3e3e;
  opacity: 0.5;
  position: absolute;
  margin-top: -30px;
}

.bgDF3E3E_2 {
  margin-left: 133px;
  margin-top: -20px;
  text-align: center;
  line-height: 3;
  color: #ffffff;
  background: #df3e3e;
  opacity: 1;
}

.notice-border {
  margin-top: 40px;
  width: 630px;
}

.notice-border-text {
  width: 200px;
  padding-left: 40px;
  font-weight: 600;
  font-size: 20px;
  color: #222222;
  padding-top: 8px;
  line-height: 0px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.notice-border-more {
  float: right;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 0px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.bgC52D23 {
  width: 12px;
  margin-left: 15px;
  height: 12px;
  background: #c52d23;
  opacity: 1;
  position: absolute;
  margin-top: 0px;
}

.bgC52D23_2 {
  margin-left: 20px;
  margin-top: 5px;
  text-align: center;
  line-height: 3;
  background: #c52d23;
  opacity: 0.2;
}

.notice-content {
  margin: 30px 0px;
  width: 630px;
  height: 314px;
  background: #ffffff;
  box-shadow: 0px 1px 6px 1px rgba(0, 0, 0, 0.16);
  border: 1px solid #cccccc;
  opacity: 1;
}

.circle {
  width: 6px;
  /* 圆点的宽度 */
  height: 6px;
  /* 圆点的高度 */
  background-color: #c52d23;
  /* 圆点的背景颜色 */
  border-radius: 50%;
  /* 将方块变成圆形 */
  margin-right: 10px;
  /* 可选：调整圆点和文本之间的间距 */
}

.notice-text {
  justify-content: space-between;
  list-style-type: square;
  font-size: 16px;
  padding: 20px 20px 0px 20px;
  list-style-type: disc;
  color: #c52d23;
  display: flex;
}

.circle-with-text {
  display: flex;
  align-items: center;
  /* 垂直居中 */
}

/* 轮播图 */
.bg-pink {
  overflow: hidden;
  position: relative;
  padding-left: 10px;
}

.swiper-box {
  display: flex;
  width: 100%;
  transition: all 0.2s;
}

[class^="el-icon-arrow-"] {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 30px;
  padding: 0px 10px;
  cursor: pointer;
}

.el-icon-arrow-left {
  left: -7px;
}

.el-icon-arrow-right {
  right: -7px;
}

.card-item {
  padding: 10px;
  box-sizing: border-box;
}

.image {
  width: 100%;
  display: block;
  max-height: 442px;
  max-width: 310px;
}
</style>
